import {Component} from "react";
import PropTypes from "prop-types";
import "./MultiColumnBrowser.css";

const prefix="MultiColumnBrowserContainer";

/** @type {MultiColumnBrowserContainerComponent} */
const MultiColumnBrowserContainer = class extends Component {
	static propTypes = {
		className: PropTypes.string,
		style: PropTypes.object,
		width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		children: PropTypes.oneOfType([
			PropTypes.arrayOf(PropTypes.node),
			PropTypes.node
		])
	}
	constructor(props) {
		super(props);
		const cn = [prefix];
		if (props.className) cn.push(props.className);
		if (! props.children || (Array.isArray(props.children) && props.children.length===0 )) cn.push('empty');
		const style = props.style ?? {};
		if ( props.width ) {
			if ( typeof props.width === "number" ) {
				style.minWidth = style.maxWidth = String(props.width)+'px';
			} else if ( typeof props.width === "string" ) {
				style.minWidth = style.maxWidth = props.width;
			}
		}
		this.state = {
			className: cn.join(' '),
			style: style,
		}
	}

	render() {
		return (
			<div
				className={this.state.className}
				style={this.state.style}
			>
				<div>
					{ this.props.children }
				</div>
			</div>
		)
	}
}

export default MultiColumnBrowserContainer;